export enum IntegrationType {
  CALENDLY = "calendly",
  CALENDAR = "calendar",
  WHATSAPP = "whatsapp",
  MESSENGER = "messenger",
  SLACK = "slack",
  TELEGRAM = "telegram",
  ZENDESK = "zendesk",
  FRESHDESK = "freshdesk",
  ZENDESK_LIVE_AGENT_HANDOFF = "zendesk_live_agent_handoff",
  SALESFORCE_LEADS = "salesforce_leads",
  SALESFORCE_LIVE_AGENT_HANDOFF = "salesforce_live_agent_handoff",
  FOLLOW_UP_QUES_SUPPORT_REQUEST = "follow_up_ques_support_request",
}
